import { OrbitalLoader } from '../ui/OrbitalLoader'

/**
 * Shown while a lazily-loaded route arrives, or while auth is being restored
 * on a hard refresh.
 *
 * Centred on the full viewport (min-h-dvh, not just the content slot it
 * happens to render inside) — this appears both nested inside the app shell
 * and standalone before the shell has mounted at all, and it should look and
 * sit the same way in both cases: the one loading affordance for the whole
 * app, dead centre of the screen.
 */
export default function RouteFallback() {
  return (
    <div className="flex min-h-dvh w-full items-center justify-center">
      <OrbitalLoader />
    </div>
  )
}
